import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

const useStyles = createUseStyles((_) => ({
  // Outer shell: locks the viewport height so the content area scrolls on its own.
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  // Scrollable content region to the right of the sidebar rail.
  billingRoot: {
    overflowY: "auto",
    padding: "30px clamp(16px, 3vw, 30px)",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    // Reserve room for the floating hamburger once the rail becomes a drawer.
    "@media (max-width:899.95px)": {
      paddingTop: "68px",
    },
  },
}));

export default useStyles;
